import { Injectable } from '@angular/core';
import { ApiError, BaseReportService, ConfigServerService, CustomHttp } from '../../../../../core';
import { PedidoOrcamentoPrintRequestPayload } from '../adapters';
import { PEDIDOS_ORCAMENTOS_REPORTS_API_RESOURCE } from '../consts';

@Injectable({
    providedIn: 'root'
})
export class PedidoOrcamentoReportHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp,
                private baseReportService: BaseReportService) {
        this.pathApi = `${configServerService.getReportsAPIResource()}/${PEDIDOS_ORCAMENTOS_REPORTS_API_RESOURCE}`;
    }

    /** Realiza a impressão do orçamento informado */
    print(payload: PedidoOrcamentoPrintRequestPayload): Promise<void | ApiError> {
        return new Promise<void>((resolve, reject) => {
            this.customHttp.post<Blob>(`${this.pathApi}/${payload?.id}`, payload, { responseType: 'blob' })
                .subscribe(
                    pdf => {
                        this.baseReportService.open(pdf);
                        resolve();
                    },
                    error => {
                        this.baseReportService.openError(error);
                        reject(error);
                    }
                )
        });
    }
}
